import { proxy, useSnapshot } from "valtio";

interface Snackbar {
	id: string;
	text: string;
	/** The time at which to close the snackbar */
	closeTime: number;
}

interface AddSnackbarOptions {
	id: string;
	text: string;
	/** The time at which to close the snackbar */
	closeTime?: number;
}
interface ISnackbarState {
	snackbar: Snackbar | null;
	stack: Snackbar[];
	addSnackbar: (snackbar: AddSnackbarOptions) => void;
	removeSnackbar: (snackbar: Snackbar) => void;
}

const state = proxy<ISnackbarState>({
	snackbar: null,
	stack: [],

	addSnackbar: (snackbar) => {
		if (state.stack.find((t) => snackbar.id === t.id)) {
			return;
		}

		// Add missing values and make a copy
		const snackbarToAdd = {
			closeTime: Date.now() + 4000, // Add absolute close time in request
			...snackbar,
		};

		state.stack.push(snackbarToAdd);

		if (state.stack.length === 1) {
			state.snackbar = snackbarToAdd;
		}
	},

	removeSnackbar: (snackbar) => {
		const index = state.stack.findIndex((s) => s.id === snackbar.id);

		if (index < 0) return;

		state.stack.splice(index, 1);

		if (index === 0) {
			const [first] = state.stack;

			state.snackbar = first;
		}
	},
});

export const useSnackbar: () => Omit<ISnackbarState, "stack"> = () => useSnapshot(state);
